import './App.css';
import PlayerSearch from './PlayerSearch';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import StatsPage from './StatsPage';
import ResultsPage from './ResultsPage';
import TopPlayers from './TopPlayers';
import BracketPrediction from './BracketPrediction';
function App() {
  return (
    <div className="App">
      <header className="App-header">
        <Router>
          <Routes>
            <Route path="/stats/:id" element={<StatsPage />} />
            <Route path="/stats" element={<StatsPage />} />
            <Route path="/results/:id" element={<ResultsPage />} />
            <Route path="/results" element={<ResultsPage />} />
            <Route path="/bracket-prediction" element={<BracketPrediction />} />
            <Route path="/top-50" element={<TopPlayers />} />
            <Route path="/:userNameEncoded" caseSensitive={false} element={<LoggerWrapper />} />
            <Route path="/" element={<LoggerWrapper />} />
          </Routes>
        </Router>
      </header>
    </div>
  );
}

// Logger wrapper component for debugging
function LoggerWrapper() {
  return (
    <>
      {console.log("Navigated to a specific user route")}
      <PlayerSearch />
    </>
  );
}

export default App;
